const { REACT_APP_INSIGHTS_URL = '' } = process.env

export const NAMESPACE = 'emailApi'

export const ENDPOINTS = {
  INVOICE_PDF: `${REACT_APP_INSIGHTS_URL}/reports/invoice/:invoiceId/pdf`,
}
